"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = require("./Button.styles");

var _Icon = require("../icon/Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Button = ({
  text,
  icon,
  showIcon,
  isPrimary,
  iconSize,
  iconPosition,
  ...rest
}) => {
  const Icon = icon && _Icon.Icons[icon];

  if (showIcon && !isPrimary) {
    return /*#__PURE__*/_react.default.createElement(_Button.StyledButton, rest, /*#__PURE__*/_react.default.createElement(_Button.StyledButtonWithIconWrapper, {
      iconPosition: iconPosition
    }, Icon && /*#__PURE__*/_react.default.createElement(Icon, {
      className: "icon left-icon",
      size: iconSize
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "button-text"
    }, text)));
  }

  return /*#__PURE__*/_react.default.createElement(_Button.StyledButton, _extends({}, rest, {
    isPrimary: isPrimary
  }), text);
};

exports.Button = Button;
Button.defaultProps = {
  disabled: false,
  isPrimary: true,
  isTertiary: false,
  size: 'large',
  theme: 'none',
  onClick: () => {},
  showIcon: false,
  iconSize: 12,
  icon: 'Add',
  iconPosition: 'left'
};
Button.propTypes = {
  /** Button Text*/
  text: _propTypes.default.oneOfType([_propTypes.default.string]).isRequired,

  /** Function Callback*/
  onClick: _propTypes.default.func.isRequired,

  /** By Default isPrimary=true*/
  isPrimary: _propTypes.default.bool,

  /** Size of the button 'small'  & 'large'*/
  size: _propTypes.default.oneOf(['small', 'large']),

  /** Theme 'none',  'light'  & 'dark'*/
  theme: _propTypes.default.oneOf(['none', 'dark', 'light']),

  /** To Disable Button  default is false*/
  disabled: _propTypes.default.bool,

  /** To enable third button style, default is false*/
  isTertiary: _propTypes.default.bool,

  /**
   * Show/Hide Icon.
   * Only applicable on Secondary Button for now. */
  showIcon: _propTypes.default.bool,

  /** Icon 'Add, Edit, Close, DownArrow', default null*/
  icon: _propTypes.default.string,

  /** Icon Size. 8, 10, 12, 14, 16 , 18 and 24 */
  iconSize: _propTypes.default.number,

  /** Icon position */
  iconPosition: _propTypes.default.string
};